<template>
  <div class="fillcontain">
    <search-item
      @showDialog="showAddStudentDialog"
      @searchList="getStudentList"
      @changePageAndLimit="handleChangePageAndLimit"
      @batchDelStudent="onBatchDelStudent"
      @exportData="exportDataOut"
      @exportTwoWeekData="exportTwoWeekDataOut"
      @batchDisableReciveMessage="disableReciveMessage"
      @batchEnableReciveMessage="enableReciveMessage"
    ></search-item>
    <div class="table_container">
      <el-table
        v-loading="loading"
        :data="tableData"
        style="width: 100%"
        border
        align="center"
        @select="selectTable"
        @select-all="selectAll"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="expand">
          <template slot-scope="props">
            <el-form label-position="left" inline class="demo-table-expand">
              <el-form-item label="小名">
                <span>{{ props.row.stdNickname }}</span>
              </el-form-item>
              <el-form-item label="地区">
                <span>{{ props.row.stdArea }}</span>
              </el-form-item>
              <el-form-item label="坐骑">
                <span>{{ props.row.stdBike }}</span>
              </el-form-item>
              <el-form-item label="家长联系电话">
                <span>{{ props.row.stdTeleponeNumber }}</span>
              </el-form-item>
              <el-form-item label="家长">
                <span>{{ props.row.stdParentName }}</span>
              </el-form-item>
              <el-form-item label="年龄组">
                <span>{{ props.row.ageGroup }}</span>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>
        <el-table-column
          width="10"
          v-if="idFlag"
          prop="stdId"
          label="stdId"
          align="left"
        ></el-table-column>
        <el-table-column
          width="50"
          type="selection"
          align="left"
          fit
        ></el-table-column>
        <el-table-column
          width="100"
          prop="stdName"
          label="姓名"
          align="left"
        ></el-table-column>
        <!-- <el-table-column width="100" prop="stdNickName" label="小名" align="left"></el-table-column> -->
        <!-- <el-table-column prop="stdSex" label="学员性别" align="center"></el-table-column> -->
        <el-table-column
          width="70"
          prop="stdAge"
          label="年龄"
          align="left"
          sortable
        >
          <template slot-scope="scope">
            {{scope.row.stdBirthday | calcStudentAge}}岁
          </template>
        </el-table-column>
        <el-table-column
          width="140"
          prop="stdBirthday"
          label="学员生日"
          align="left"
          sortable
        >
          <template slot-scope="scope">
            <el-icon name="time"></el-icon>
            <span style="margin-left: 10px">{{
              scope.row.stdBirthday | filterTime
            }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column width="70" prop="stdArea" label="地区" align="left"></el-table-column> -->
        <!-- <el-table-column width="70" prop="stdBike" label="坐骑" align="left"></el-table-column> -->
        <!-- <el-table-column width="100" prop="stdTelephoneNumber" label="家长联系电话" align="left"></el-table-column> -->
        <!-- <el-table-column width="100" prop="stdParentName" label="家长" align="left"></el-table-column> -->
        <el-table-column
          width="100"
          prop="stdStatus"
          label="学员状态"
          width:100
          :filters="fields.statusType.filter.list"
          :filter-method="filterStdStatus"
          filter-placement="bottom-end"
          fit
        >
          <template slot-scope="scope">
            <el-tag
              v-html="formatterStdStatus(scope.row)"
              :type="
                scope.row.stdStatus === 0
                  ? 'warning'
                  : scope.row.stdStatus === 1
                  ? 'success'
                  : 'error'
              "
              disable-transitions
              >{{ scope.row.stdStatus }}</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column
          width="160"
          prop="lastAppointmentTime"
          label="最后约课时间"
          align="left"
        ></el-table-column>
        <el-table-column
          width="100"
          prop="mesFlag"
          label="短信通知"
          align="left"
        >
          <template slot-scope="scope">
            <div>{{scope.row.mesFlag === 0 ? '禁用' : (scope.row.mesFlag === 1 ? '启用' : '')}}</div>
          </template>
        </el-table-column>
        <el-table-column
          width="100"
          prop="cancelNum"
          label="取消次数"
          align="left"
        ></el-table-column>
        <el-table-column
          width="100"
          prop="cancelMonth"
          label="月份"
          align="left"
        ></el-table-column>
        <!-- <el-table-column
          width="100"
          prop="stdIsPassExam"
          label="通过初级一班考核"
          :filters="fields.isPassExam.filter.list"
          :filter-method="filterIsPassExam"
          filter-placement="bottom-end"
          fit
        >
          <template slot-scope="scope">
            <el-tag
              v-html="formatterIsPassExam(scope.row)"
              :type="scope.row.stdIsPassExam === true ? 'danger' : 'success'"
              disable-transitions
            >{{scope.row.stdIsPassExam}}</el-tag>
          </template>
        </el-table-column>-->
        <!-- <el-table-column
          width="100"
          prop="stdIsPassExam1"
          label="通过初级二班考核"
          :filters="fields.isPassExam.filter.list"
          :filter-method="filterIsPassExam1"
          filter-placement="bottom-end"
          fit
        >
          <template slot-scope="scope">
            <el-tag
              v-html="formatterIsPassExam1(scope.row)"
              :type="scope.row.stdIsPassExam1 === true ? 'danger' : 'success'"
              disable-transitions
            >{{scope.row.stdIsPassExam1}}</el-tag>
          </template>
        </el-table-column>-->
        <!-- <el-table-column
          width="100"
          prop="stdIsPassHighExam"
          label="通过进阶考核"
          :filters="fields.isPassHighExam.filter.list"
          :filter-method="filterIsPassHighExam"
          filter-placement="bottom-end"
          fit
        >
          <template slot-scope="scope">
            <el-tag
              v-html="formatterIsPassHighExam(scope.row)"
              :type="scope.row.stdIsPassHighExam === true ? 'danger' : 'success'"
              disable-transitions
            >{{scope.row.stdIsPassHighExam}}</el-tag>
          </template>
        </el-table-column>-->
        <!-- <el-table-column
          width="100"
          prop="stdIsPassTeamExam"
          label="通过战队练考核"
          :filters="fields.isPassHighExam.filter.list"
          :filter-method="filterIsPassTeamExam"
          filter-placement="bottom-end"
          fit
        >
          <template slot-scope="scope">
            <el-tag
              v-html="formatterIsPassTeamExam(scope.row)"
              :type="scope.row.stdIsPassTeamExam === true ? 'danger' : 'success'"
              disable-transitions
            >{{scope.row.stdIsPassTeamExam}}</el-tag>
          </template>
        </el-table-column>-->
        <el-table-column prop="operation" align="left" label="操作" fit>
          <template slot-scope="scope">
            <el-button
              v-show="ROLE == 1"
              type="warning"
              icon="edit"
              size="mini"
              @click="onEditStudent(scope.row)"
              >编辑</el-button
            >
            <el-button
              v-show="ROLE == 1"
              type="danger"
              icon="delete"
              size="mini"
              @click="onDeleteStudent(scope.row, scope.$index)"
              >删除</el-button
            >
          </template>
        </el-table-column>
        <el-table-column prop="operation" align="left" label="操作" fit>
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="mini"
              @click="onGotoRecordPage(scope.row, scope.$index)"
              >课堂</el-button
            >
            <el-button
              type="success"
              size="mini"
              @click="onGotoEventPage(scope.row, scope.$index)"
              >事件</el-button
            >
            <el-button
              type="success"
              size="mini"
              @click="onGotoClassTypePage(scope.row, scope.$index)"
              >班级类型</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :pageTotal="pageTotal"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      ></pagination>
      <addFundDialog
        v-if="addStudentDialog.show"
        :isShow="addStudentDialog.show"
        :dialogRow="addStudentDialog.dialogRow"
        :memberLists="addStudentDialog.memberList"
        @getStudentList="getStudentList"
        @closeDialog="hideAddFundDialog"
      ></addFundDialog>
    </div>
  </div>
</template>


<script>
import { mapGetters } from "vuex";
import * as mutils from "@/utils/mUtils";
import SearchItem from "./components/searchItem";
import AddFundDialog from "./components/addStudentDialog";
import { myTime, formatDateTime } from "../../utils/date.js";
import Pagination from "@/components/pagination";
import {
  getStudentInfo,
  deleteStudent,
  batchDeleteStudent,
  excelDownloadStudents,
  excelDownloadTwoMonthStudents,
  batchUnSendStudent,
  batchSetSendStudent
} from "@/api/student";
import { getToken } from "@/utils/auth";
import { addOperationRecord } from "@/api/operationrecord";

export default {
  data() {
    return {
      tableData: [],
      tableHeight: 0,
      loading: false,
      idFlag: false,
      isShow: false, // 是否显示资金modal,默认为false
      editid: "",
      ROLE: 0,
      multipleSelection: [], //多选的数据
      sortnum: 0,
      format_member_type_list: {
        0: "临时会员",
        1: "正式会员",
      },
      format_ispass_list: {
        true: "否",
        false: "是",
      },
      format_ispass_high_list: {
        true: "否",
        false: "是",
      },
      format_std_status_list: {
        0: "未审核",
        1: "审核通过",
        2: "审核失败",
      },
      addStudentDialog: {
        show: false,
        memberList: {},
        dialogRow: {},
      },
      studentData: {
        page: 1,
        limit: 20,
      },
      pageTotal: 0,
      // 用于列表筛选
      fields: {
        statusType: {
          filter: {
            list: [
              {
                text: "未审核",
                value: 0,
              },
              {
                text: "审核通过",
                value: 1,
              },
              {
                text: "审核失败",
                value: 2,
              },
            ],
          },
        },
        memberType: {
          filter: {
            list: [
              {
                text: "临时会员",
                value: 0,
              },
              {
                text: "正式会员",
                value: 1,
              },
            ],
          },
        },
        isPassExam: {
          filter: {
            list: [
              {
                text: "是",
                value: false,
              },
              {
                text: "否",
                value: true,
              },
            ],
          },
        },
        isPassHighExam: {
          filter: {
            list: [
              {
                text: "是",
                value: false,
              },
              {
                text: "否",
                value: true,
              },
            ],
          },
        },
      },
    };
  },
  components: {
    SearchItem,
    AddFundDialog,
    Pagination,
  },
  computed: {
    ...mapGetters(["studentSearch", "roles"]),
  },
  filters: {
    filterTime(time) {
      //var dd = myTime(time);
      return formatDateTime(time);
    },
    calcStudentAge(startDate) {
      var date = new Date();
      startDate = new Date(startDate);
      var newDate = date.getTime() - startDate.getTime();
      // 向下取整  例如 10岁 20天 会计算成 10岁
      // 如果要向上取整 计算成11岁，把floor替换成 ceil
      return Math.floor(newDate / 1000 / 60 / 60 / 24 / 365);
    }
  },
  created() {
    this.ROLE = getToken("ROLE");
  },
  mounted() {
    this.getStudentList();
    // getAllMemberInfo({}).then(res => {
    //   console.log(res.data.data.allMemberList);
    //   var allMemberList = res.data.data.allMemberList;
    //   var memberlist = {
    //     memberList: allMemberList
    //   };
    //   this.addStudentDialog.memberList = memberlist;
    //   //   this.$store.commit('SET_MEMBER_LIST',allMemberList);
    // });
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log(this.multipleSelection);
    },
    handleChangePageAndLimit() {
      this.studentData.page = 1;
      this.studentData.limit = 20;
    },
    handleFilterChange(filters) {
      console.log("filters:");
      for (const i in filters) {
        console.log(filters[i]);
      }
    },
    setTableHeight() {
      this.$nextTick(() => {
        this.tableHeight = document.body.clientHeight - 300;
      });
    },
    //点击事件按钮跳转到课堂记录管理页面
    onGotoRecordPage(row) {
      const para = { stdId: row.stdId };
      this.$store.commit("SET_RECORD_SEARCH", para);
      this.$router.push({ path: "/studentManage/courseRecord" });
    },
    //点击事件按钮跳转到事件管理页面
    onGotoEventPage(row) {
      const para = { stdId: row.stdId };
      this.$store.commit("SET_EVENT_SEARCH", para);
      this.$router.push({ path: "/studentManage/eventNote" });
    },
    onGotoClassTypePage(row) {
      const para = { stdId: row.stdId, stdName: row.stdName };
      this.$store.commit("SET_STUDENTANDCLASSTYPE_SEARCH", para);
      this.$router.push({ path: "/studentManage/studentAndClassTypeList" });
    },
    //获取学员列表数据
    getStudentList() {
      console.log(this.studentData);
      const para = Object.assign({}, this.studentData, this.studentSearch);
      console.log(para);
      getStudentInfo(para).then((res) => {
        console.log(res);
        this.loading = false;
        this.pageTotal = res.data.data.total;
        this.tableData = res.data.data.studentData;
        // this.$store.commit("SET_STUDENT_SEARCH", "");
      });
    },
    // 显示资金弹框
    showAddStudentDialog(val) {
      this.$store.commit("SET_STUDENT_DIALOG_TITLE", val);
      this.addStudentDialog.show = true;
    },
    hideAddFundDialog() {
      this.addStudentDialog.show = false;
    },
    // 上下分页
    handleCurrentChange(val) {
      this.studentData.page = val;
      this.getStudentList();
    },
    // 每页显示多少条
    handleSizeChange(val) {
      this.studentData.limit = val;
      this.getStudentList();
    },
    /**
     * 格式化状态
     */
    formatterMemberType(item) {
      const type = parseInt(item.stdMemberType);
      return this.format_member_type_list[type];
    },
    formatterStdStatus(item) {
      const type = parseInt(item.stdStatus);
      return this.format_std_status_list[type];
    },
    formatterIsPassExam(item) {
      // const type = parseInt(item.stdIsPassExam);
      return this.format_ispass_list[item.stdIsPassExam];
    },
    formatterIsPassExam1(item) {
      // const type = parseInt(item.stdIsPassExam);
      return this.format_ispass_list[item.stdIsPassExam1];
    },
    formatterIsPassHighExam(item) {
      return this.format_ispass_high_list[item.stdIsPassHighExam];
    },
    formatterIsPassTeamExam(item) {
      return this.format_ispass_high_list[item.stdIsPassTeamExam];
    },
    filterStdStatus(value, item) {
      const type = parseInt(item.stdStatus);
      return (
        this.format_std_status_list[value] == this.format_std_status_list[type]
      );
    },
    filterMemberType(value, item) {
      const type = parseInt(item.stdMemberType);
      return (
        this.format_member_type_list[value] ==
        this.format_member_type_list[type]
      );
    },
    filterIsPassExam(value, item) {
      //   const type = parseInt(item.stdIsPassExam);
      return (
        this.format_ispass_list[value] ==
        this.format_ispass_list[item.stdIsPassExam]
      );
    },
    filterIsPassExam1(value, item) {
      //   const type = parseInt(item.stdIsPassExam);
      return (
        this.format_ispass_list[value] ==
        this.format_ispass_list[item.stdIsPassExam1]
      );
    },
    filterIsPassHighExam(value, item) {
      return (
        this.format_ispass_high_list[value] ==
        this.format_ispass_high_list[item.stdIsPassHighExam]
      );
    },
    filterIsPassTeamExam(value, item) {
      return (
        this.format_ispass_high_list[value] ==
        this.format_ispass_high_list[item.stdIsPassTeamExam]
      );
    },
    // 编辑操作方法
    onEditStudent(row) {
      //   this.$router.push({ path: "/memberManage/fundList" });
      console.log(row);
      this.addStudentDialog.dialogRow = { ...row };
      this.showAddStudentDialog();
    },
    // 删除数据
    onDeleteStudent(row) {
      this.$confirm("是否移入回收站?", "提示", {
        type: "warning",
      })
        .then(() => {
          const para = { id: row.stdId };
          console.log(para);
          deleteStudent(para).then((res) => {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            const para = {
              userName: getToken("USERNAME"),
              content: "删除(" + row.stdName + ")学员操作",
            };
            addOperationRecord(para).then((res) => {
              console.log(res);
            });
            this.getStudentList();
          });
        })
        .catch(() => {});
    },
    onBatchDelStudent() {
      // console.log("onbatchdelmember");
      this.$confirm("确认批量删除记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          const ids = this.multipleSelection.map((item) => item.id).toString();
          const para = { ids: ids };
          batchDeleteStudent(para).then((res) => {
            // console.log(res);
            if (res.data.code == 200) {
              this.$message({
                message: "批量删除成功",
                type: "success",
              });
              this.getStudentList();
            }
          });
        })
        .catch(() => {});
    },
    //导出学生列表
    exportDataOut() {
      this.$confirm("确认要导出吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          excelDownloadStudents().then(res => {
            const content = res;
            const blob = new Blob([res.data], {
              type: " application/vnd.ms-excel",
            });
            const a = document.createElement("a");
            // 生成文件路径
            let href = window.URL.createObjectURL(blob);
            a.href = href;
            let _fileName = decodeURIComponent(
              res.headers["content-disposition"].split(";")[1].split("=")[1]
            );
            // 文件名中有中文 则对文件名进行转码
            a.download = _fileName;
            // 利用a标签做下载
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(href);
            //记录操作
            const para = {
              userName: getToken("USERNAME"),
              content: "导出学员列表",
            };
            addOperationRecord(para).then((res) => {
              console.log(res);
            });
            if (res.data.code == 200) {
              this.$message({
                message: "导出成功",
                type: "success",
              });
              this.getStudentList();
            }
          })
        })
        .catch(() => {});
    },
    // 当用户手动勾选数据行的 Checkbox 时触发的事件
    selectTable(val, row) {
      this.setSearchBtn(val);
    },
    // 用户全选checkbox时触发该事件
    selectAll(val) {
      this.setSearchBtn(val);
    },
    setSearchBtn(val) {
      let isFlag = true;
      if (val.length > 0) {
        isFlag = false;
      } else {
        isFlag = true;
      }
      this.$store.commit("SET_COURSE_SEARCHBTN_DISABLED", isFlag);
    },
    //导出两周没约课学员
    exportTwoWeekDataOut() {
      this.$confirm("确认要导出吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          console.log('导出两周没约课学员');
           excelDownloadTwoMonthStudents().then(res => {
            const content = res;
            const blob = new Blob([res.data], {
              type: " application/vnd.ms-excel",
            });
            const a = document.createElement("a");
            // 生成文件路径
            let href = window.URL.createObjectURL(blob);
            a.href = href;
            let _fileName = decodeURIComponent(
              res.headers["content-disposition"].split(";")[1].split("=")[1]
            );
            // 文件名中有中文 则对文件名进行转码
            a.download = _fileName;
            // 利用a标签做下载
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(href);
            //记录操作
            const para = {
              userName: getToken("USERNAME"),
              content: "导出两周没约课学员",
            };
            addOperationRecord(para).then((res) => {
              console.log(res);
            });
            if (res.data.code == 200) {
              this.$message({
                message: "导出成功",
                type: "success",
              });
              this.getStudentList();
            }
          })
        })
        .catch(() => {});
    },
    disableReciveMessage() {
      if(this.multipleSelection.length > 0) {
        this.$confirm("确认要禁用短信通知吗?", "提示", {
        type: "warning",
      })
      .then(() => {
        const ids = this.multipleSelection.map((item) => item.stdId).toString();
        const para = { ids: ids };
         batchUnSendStudent(para).then((res) => {
          this.$message({
            message: "禁用成功",
            type: "success",
          });
          this.getStudentList();
         })
      })
      }else {
        this.$message.error('请选择至少一条数据')
      }
    },
    enableReciveMessage() {
      if(this.multipleSelection.length > 0) {
        this.$confirm("确认要恢复短信通知吗?", "提示", {
        type: "warning",
      })
      .then(() => {
        const ids = this.multipleSelection.map((item) => item.stdId).toString();
        const para = { ids: ids };
         batchSetSendStudent(para).then((res) => {
          this.$message({
            message: "恢复成功",
            type: "success",
          });
          this.getStudentList();
         })
      })
      }else {
        this.$message.error('请选择至少一条数据')
      }
    }
  },
};
</script>


<style lang="less" scoped>
.table_container {
  padding: 10px;
  background: #fff;
  border-radius: 2px;
  overflow: auto;
}
.el-dialog--small {
  width: 600px !important;
}
.pagination {
  text-align: left;
  margin-top: 10px;
}
.demo-table-expand {
  font-size: 0;
}
.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
</style>